var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.784 9.595v4.864m3.243-4.864v4.864M3.919 6.351h12.973m-.811 0l-.703 9.845a1.621 1.621 0 0 1-1.617 1.507H7.05a1.621 1.621 0 0 1-1.618-1.507L4.73 6.351H16.08zm-3.243 0V3.92a.81.81 0 0 0-.811-.81H8.784a.81.81 0 0 0-.811.81V6.35h4.865z", stroke: "#3B97B1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});